export default {
  SET_SHORTCUTS(state, data) {
    state.shortcuts = data;
  },
};
